import { ConfigLoader, getConfig } from './ConfigLoader';

import { isNotNull } from './core/guards';

export default function apiLoader(apiKey: string): Promise<unknown> {
	apiKey = encodeURIComponent(apiKey);
	const config = getConfig();

	console.log('apiLoader...');

	return new Promise((resolve, reject) => {
		const callReadyFn = () => {
			console.log('call ym.ready...');
			ym.ready(
				{
					channel: config.channel || '',

					// brand position
					position: 'bottomright'
				},
				modules => resolve(modules)
			);
		};

		try {
			if ('object' === typeof ym && isNotNull(ym) && typeof ym.ready === 'function') {
				console.log('ym script tag is loaded');

				setTimeout(() => callReadyFn(), 50);
			} else {
				if (ConfigLoader.instance.preApiLoad) {
					ConfigLoader.instance.preApiLoad();
				}
				const script = document.createElement('script');
				script.type = 'text/javascript';
				script.async = true;
				script.src = config.apiCall(apiKey);

				script.addEventListener('load', callReadyFn);
				document.body.appendChild(script);
			}
		} catch (err) {
			reject(err);
		}
	});
}
